import { faCalendarDays } from '@fortawesome/pro-regular-svg-icons/faCalendarDays';
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { parseApiDate } from '@propertypal/shared/src/services/dayjs';
import { Auction } from '@propertypal/shared/src/types/auction';
import puralise from '@propertypal/shared/src/utils/puralise';
import React, { FunctionComponent } from 'react';
import Chevron from '../icons/Chevron';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { AgentLogo, BoxColumn, BoxRow, Container, SearchLink, TextBox } from './AuctionBox.style';

interface Props {
  auction: Auction;
}

export const getRelativeDate = (date: string, format: string) => {
  const relativeDate = parseApiDate(date);

  if (relativeDate.isToday()) return 'Today';
  if (relativeDate.isTomorrow()) return 'Tomorrow';
  return relativeDate.format(format);
};

const AuctionBox: FunctionComponent<Props> = (props) => {
  const { date, startTime, endTime, venue, totalProperties, account } = props.auction;
  const buttonText = `View ${puralise('1 Property', `All ${totalProperties} Properties`, totalProperties)}`;
  const timeText = `${parseApiDate(startTime).format('hh:mma')} - ${parseApiDate(endTime).format('hh:mma')}`;
  const timeQueryString = `${parseApiDate(date).format('YYMMDD')}-${parseApiDate(startTime).format('HHmmss')}`;
  const dateText = getRelativeDate(date, 'DD MMM');

  return (
    <Container data-testid="auction-box">
      <TextBox>
        <AgentLogo src={account.logo?.standard} alt="agent logo" />
        <h2>{account.organisation}</h2>
        <p>
          {venue.onlineOnly
            ? 'Online Auction'
            : `${venue.addressLine1}, ${venue.addressLine2}, ${venue.town}, ${venue.postcode}`}
        </p>

        {!!venue.url && (
          <p>
            <a href={venue.url} target="_blank" rel="noreferrer">
              More Details
            </a>
          </p>
        )}
      </TextBox>

      <BoxRow>
        <BoxColumn>
          <FontAwesomeIcon icon={faCalendarDays} size={24} />
          <h3>{dateText}</h3>
        </BoxColumn>
        <BoxColumn>
          <FontAwesomeIcon icon={faClock} size={24} />
          <h3>{timeText}</h3>
        </BoxColumn>
      </BoxRow>

      <SearchLink href={`/auctions?venue=${venue?.id}&time=${timeQueryString}`}>
        {buttonText} <Chevron size={14} containerStyle={{ verticalAlign: 'middle', marginTop: -3 }} />
      </SearchLink>
    </Container>
  );
};

export default AuctionBox;
